/**
 * AI アシスタントの今月の残り（円・ホームの知らせ・入力欄の下で同じ判定を使う）
 *
 * 残りが 2 割以下なら「少なくなっています」、使い切ったら「上限に達しました」。
 * プレミアム以外は、ひとつ上のプランへの案内を添える（UsageLimitBanner と同じ考え方）。
 */

import { CHAT_LOW_REMAINING_RATIO, CHAT_USAGE_LEVEL, type ChatUsageLevel } from '@/constants/chat';
import { PLAN_TYPE, nextPlanOf, type PlanType } from '@/constants/planTypes';
import type { ChatUsage } from '@/services/chat';

const PLAN_TYPES: readonly string[] = Object.values(PLAN_TYPE);

/** 今月の残り（0〜100 の整数） */
export function remainingPercent(usage: ChatUsage): number {
  return Math.max(0, Math.round((1 - usage.usedRatio) * 100));
}

export function chatUsageLevel(usage: ChatUsage): ChatUsageLevel {
  if (usage.exhausted) return CHAT_USAGE_LEVEL.EXHAUSTED;
  if (1 - usage.usedRatio <= CHAT_LOW_REMAINING_RATIO) return CHAT_USAGE_LEVEL.LOW;
  return CHAT_USAGE_LEVEL.OK;
}

/** ひとつ上のプラン（プレミアム・不明なプランなら null） */
export function chatUpgradePlan(usage: ChatUsage): PlanType | null {
  if (!PLAN_TYPES.includes(usage.planType)) return null;
  return nextPlanOf(usage.planType as PlanType);
}

/** 回復する日（例: 11月1日） */
export function formatResetDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return `${date.getMonth() + 1}月${date.getDate()}日`;
}
